<template>
  <div class="flex-center">
    <a-button
      v-if="status === FOLLOW_STATUS.NONE && isChinese()"
      class="flex-center"
      @click="toSub"
    >
      {{ $t('qu-ren-zheng') }}
      <a-tooltip placement="bottomRight" color="white" destroyTooltipOnHide>
        <template #title>
          <span class="text-font-1 whitespace-nowrap">
            {{
              $t(
                'ren-zheng-zhu-ti-hou-ke-yi-shi-yong-gen-sui-suo-ding-gong-neng'
              )
            }}
          </span>
        </template>
        <ExclamationCircleOutlined />
      </a-tooltip>
    </a-button>
    <Follow
      v-if="[FOLLOW_STATUS.FOLLOW, FOLLOW_STATUS.REFUSE].includes(status)"
      @success="$emit('success')"
    />
    <template v-if="status === FOLLOW_STATUS.FOLLOWING">
      <span class="text-16">{{ $t('gen-sui-suo-ding-shen-qing-zhong') }}</span>
      <span>
        <a-divider type="vertical" />
        <a-popconfirm
          placement="bottom"
          :ok-text="$t('que-ding')"
          :cancel-text="$t('qu-xiao')"
          :overlayInnerStyle="{
            padding: '16px 12px',
          }"
          :cancelButtonProps="{
            class: 'yy-btn-outline',
            type: 'primary',
            ghost: true,
            size: 'middle',
          }"
          :okButtonProps="{
            size: 'middle',
          }"
          :icon="false"
          @confirm="cancelLock"
        >
          <template #title>
            <span class="text-16">{{ $t('che-xiao-gen-sui-shen-qing') }}</span>
          </template>
          <template #description>
            <div class="text-font-60 w-[354px] -ml-[14px]">
              {{ $t('che-xiao-shen-qing-hou') }}，
              <span class="text-font-1">{{ orgName || userName }}</span>
              {{
                $t(
                  'jiang-wu-fa-shen-pi-nin-de-gen-sui-shen-qing-que-ren-shi-fou-che-xiao-gen-sui-shen-qing'
                )
              }}
            </div>
          </template>
          <a class="cursor-pointer text-16">{{ $t('che-hui') }}</a>
        </a-popconfirm>
      </span>
    </template>
    <template v-if="status === FOLLOW_STATUS.FOLLOWED">
      <span class="text-16">{{ $t('gen-sui-suo-ding-zhong') }}</span>
      <a-divider type="vertical" />
      <a class="cursor-pointer text-16" @click.prevent="unlock">
        {{ $t('jie-suo') }}
      </a>
    </template>
    <a-button
      v-if="
        status === FOLLOW_STATUS.FOLLOWING || status === FOLLOW_STATUS.FOLLOWED
      "
      type="primary"
      :disabled="status === FOLLOW_STATUS.FOLLOWING"
      ghost
      hover
      class="ml-[20px] flex-center"
    >
      <Resource :src="flowIconUrl" class="w-[20px] h-[20px] mr-[6px]" />
      {{ orgName || userName }}
    </a-button>
  </div>
</template>
<script lang="ts" name="FollowLock" setup>
import Follow from './follow.vue'
import { secureFollow } from '~/api'
import { FOLLOW_STATUS } from '~/api/interface'
import { useConfirm } from '~/hooks/useModal/modals/confirm'
import flowIconUrl from '@/assets/svg/follow.svg?url'

const props = defineProps<{
  status: number
  userName?: string
  orgName?: string
  fromOrgName?: string
}>()

const emit = defineEmits(['success'])
const { $t } = useNuxtApp()

const unlock = () => {
  useConfirm({
    title: $t('jie-chu-guan-xi'),
    icon: true,
    description: h('span', null, [
      $t(
        'jie-chu-guan-xi-hou-pin-pai-gui-fan-zhong-de-nei-rong-hui-hui-fu-wei'
      ),
      h('b', { class: 'text-primary' }, props?.fromOrgName),
      $t('she-zhi-de-pin-pai-gui-fan-shu-yu'),
      h('b', { class: 'text-primary' }, props?.orgName),
      $t('de-pin-pai-gui-fan-nei-rong-jie-chu-hou-jiang-wu-fa-shi-yong'),
    ]),
    onOk: async () => {
      await cancelLock()
      emit('success')
    },
  })
}

const cancelLock = async () => {
  const res = await secureFollow()
  if (res.code !== 0) {
    return
  }
  message.success(
    props.status === FOLLOW_STATUS.FOLLOWING
      ? $t('che-hui-cheng-gong')
      : $t('jie-chu-cheng-gong')
  )
  emit('success')
}

const toSub = () => {
  const router = useRouter()
  router.push({ name: 'subjectManage' })
}
</script>
